import { highSamplingRateIcon } from '@/shared/ui/assets';
import { Chip, CustomTooltip } from '@/shared/ui/components';
import classNames from 'classnames';
import { t } from 'ttag';
import './highSamplingRate.scss';

const HighSamplingRate = ({
  className = '',
  hasTooltip = false,
}: {
  hasTooltip?: boolean;
  className?: string;
}) =>
  hasTooltip ? (
    <CustomTooltip title={t`This device is operating at a high sampling rate`} placement="bottom">
      <div className={classNames('high-sampling-rate-icon', className)}>
        <img id="high-sampling-rate" src={highSamplingRateIcon} alt="High Sampling Rate Icon" />
      </div>
    </CustomTooltip>
  ) : (
    <Chip
      className={className}
      style={{ border: 1, paddingInline: 8 }}
      background="#DEF5EF"
      color="#045C45"
      closable={false}
    >
      {t`High sampling rate`}
    </Chip>
  );

export default HighSamplingRate;
